<div id="app-reducao-carencia-proposta">
  <section>
    <div class="documento-aditivo-container">
      <app-header-documento-final-proposta
        [entidadeProposta]="entidadeProposta"
        [razaoSocialEntidade]="razaoSocialEntidade"
        [codigoProposta]="codigoProposta"
        [vigenciaProposta]="vigenciaProposta"
        [operadoraVM]="operadoraVM"
        [dadosOperadoraCabecalho]="dadosOperadoraCabecalho"></app-header-documento-final-proposta>
      <h3 class="titulo text-center bold-preto-700 mb-1 p-1" style="background: #ccc; border-radius: 10px">
        Formulário de Carências
      </h3>
      <div class="col-md-12 col-sm-12 mt-1">
        <p class="espacamento-text-mobile">
          O presente formulário tem por objetivo evidenciar as condições contratuais referentes ao cumprimento dos
          períodos de carências, previstos no inciso V do art. 12 da Lei 9.656/98, que regulamenta os planos de saúde no
          Brasil, e fixados no contrato ao qual se vincula o beneficiário, conforme abaixo:
        </p>
      </div>
      <ng-container *ngIf="heMedSenior">
        <app-reducao-carencia-medSenior [titulo]="'Redução de Carências da MedSenior'"></app-reducao-carencia-medSenior>

        <br />
        <div *ngIf="isDataDentroDoPeriodo()">
          <div class="documento-aditivo-container">
            <h3 class="titulo text-center bold-preto-700 mb-1 p-1 mt-5" style="background: #ccc; border-radius: 10px">
              ADITIVO DE ISENÇÃO DE CARÊNCIAS - MEDSÊNIOR
            </h3>
            <div class="col-md-12 col-sm-12 mt-1">
              <p class="mb-1">
                <b>2) CLÁUSULA PRIMEIRA - DO OBJETO 1.1</b>
                Através do presente aditivo contratual, que é parte integrante e inseparável do contrato principal,
                devidamente qualificado da proposta contratual, a Géia Administradora, através da autorização da
                Medsenior, no exercício de sua faculdade, resolve isentar de carências contratuais, exceto CPT, os
                beneficiários, conforme regras abaixo descrita.
              </p>

              <p class="mb-1">Mínimo de 6 meses de plano anterior (exceto CPT);</p>
              <p class="mb-1">Cancelamento deve ter ocorrido em até 30 dias ou estar ativo;</p>
            </div>
            <div class="col-md-12 col-sm-12">
              <p class="bold text-center">
                Todos os contratos com
                <strong>APROVEITAMENTO DE CARÊNCIAS</strong>
                passarão por análise de aceitação.
              </p>
            </div>
            <div class="col-md-12 col-sm-12 mt-1">
              <p class="mb-1">
                *Válido para propostas assinadas e encaminhadas para a Operadora no período de 01/07/2026 a 01/12/2026.
              </p>

              <p class="mb-1">
                E por estarem assim justas e contratadas, assinam o presente aditivo contratual em duas vias de igual
                teor para um só efeito. Salientando que o aditivo entrará em vigor, a partir da data de vigência
                mencionada no contrato principal.
              </p>
              <hr />
            </div>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="!heMedSenior">
        <h3 class="titulo text-center bold-preto-700 mt-1 mb-1 p-1">QUADRO 1</h3>

        <table class="table table-bordered">
          <thead>
            <tr>
              <th style="background: #ccc">DESCRIÇÃO</th>
              <th style="background: #ccc">PERÍODO</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <b>URGÊNCIAS E EMERGÊNCIAS - ACIDENTES PESSOAIS</b>
                (conforme resolução CONSU nº 13/88)
              </td>
              <td>24 HORAS</td>
            </tr>
            <tr>
              <td><b>CONSULTAS E EXAMES COMPLEMENTARES</b></td>
              <td>30 DIAS</td>
            </tr>
            <tr>
              <td>
                <b>FISIOTERAPIAS, EXAMES ESPECIAIS E PROCEDIMENTOS AMBULATORIAIS</b>
              </td>
              <td>90 DIAS</td>
            </tr>
            <tr>
              <td>
                <b>INTERNAÇÕES CLÍNICAS E CIRÚRGICAS, QUIMIOTERAPIA, RADIOTERAPIA, DIÁLISE E HEMODIÁLISE</b>
              </td>
              <td>180 DIAS</td>
            </tr>
            <tr>
              <td><b>PARTO A TERMOS</b></td>
              <td>300 DIAS</td>
            </tr>
          </tbody>
        </table>
      </ng-container>

      <div class="col-md-12 col-sm-12 mt-1 espacamento-text-mobile">
        <p>
          Em regra, todos os beneficiários devem cumprir os períodos de carências, acima estipulados, para ter acesso as
          coberturas contratadas.
        </p>
        <p class="mb-1">
          E por estarem assim justas e contratadas, assinam o presente aditivo contratual em duas vias de igual teor
          para um só efeito. Salientando que o aditivo entrará em vigor, a partir da data de vigência mencionada no
          contrato principal.
        </p>

        <p>
          No entanto, com o objetivo de incentivar a migração de beneficiários oriundos de outras operadoras, a
          administradora poderá conceder isenção total ou parcial das carências contratualmente previstas, a seu
          exclusivo critério, exceto para partos a termo (300 dias). Dessa forma, caso seja de interesse do beneficiário
          submeter-se a análise técnica da administradora, marque a opção correspondente:
        </p>
      </div>

      <div class="card-content col-md-12 col-sm-12 mt-1">
        <form [formGroup]="formularioReducaoCarencia">
          <div class="form-group mb-1 col-sm-12 col-md-12 declaracao-options">
            <div class="row option-row espacamento-text-mobile">
              <label class="checkbox-container">
                <input
                  type="radio"
                  [checked]="beneficiariosComReducaoCarencia.length"
                  disabled
                  class="hidden-checkbox" />
                <span class="checkmark"></span>
                <span class="option-text">
                  <p *ngIf="beneficiariosComReducaoCarencia.length === 1">
                    O beneficiário
                    <span class="bold-preto-700" style="color: black">
                      {{ beneficiariosComReducaoCarencia.join(', ') }}:
                    </span>
                  </p>
                  <p *ngIf="beneficiariosComReducaoCarencia.length > 1">
                    Os beneficiários
                    <span class="bold-preto-700" style="color: black">
                      {{ beneficiariosComReducaoCarencia.join(', ') }}:
                    </span>
                  </p>

                  Deseja(m) submeter-se a Análise Técnica de Redução de Carências e declaro ter conhecimento de que a
                  análise atenderá a critérios técnicos internos da administradora, que tem a faculdade de conceder ou
                  não a redução de carências.
                </span>
              </label>
            </div>
            <div class="row option-row espacamento-text-mobile">
              <label class="checkbox-container">
                <input
                  type="radio"
                  [checked]="beneficiariosSemReducaoCarencia.length"
                  disabled
                  class="hidden-checkbox" />
                <span class="checkmark"></span>
                <span class="option-text">
                  <p *ngIf="beneficiariosSemReducaoCarencia.length === 1">
                    O beneficiário
                    <span class="bold-preto-700" style="color: black">
                      {{ beneficiariosSemReducaoCarencia.join(', ') }}:
                    </span>
                  </p>
                  <p *ngIf="beneficiariosSemReducaoCarencia.length > 1">
                    Os beneficiários
                    <span class="bold-preto-700" style="color: black">
                      {{ beneficiariosSemReducaoCarencia.join(', ') }}:
                    </span>
                  </p>
                  Dispensa(m) a Análise Técnica de Redução de Carências e declaro estar ciente de que ao aderir ao plano
                  de saúde, as coberturas contratuais estarão condicionadas ao cumprimento dos períodos de carência
                  informados no Quadro 1 acima.
                </span>
              </label>
            </div>
          </div>
        </form>
      </div>
      <!-- Reduçao de Carências (campanhas)-->
      <div *ngIf="ehCampanhaAniversarioFesp(dataCriacaoProposta) || ehCampanhaUDEMO(dataCriacaoProposta)">
        <div class="documento-aditivo-container">
          <h3 class="titulo text-center bold-preto-700 mb-1 p-1 mt-5" style="background: #ccc; border-radius: 10px">
            ADITIVO DE REDUÇÃO DE CARÊNCIAS
          </h3>
          <div class="col-md-12 col-sm-12 mt-1">
            <p class="mb-1">
              <b>1) CLÁUSULA PRIMEIRA - DO OBJETO</b>
              1.1 Através do presente aditivo contratual, que é parte integrante e inseparável do contrato principal,
              devidamente qualificado da proposta contratual, a Géia Administradora, no exercício de sua faculdade,
              resolve isentar os beneficiários do cumprimento de carências conforme tabela abaixo.
            </p>
            <p class="mb-1">
              <b>2) CLÁUSULA SEGUNDA – DAS REDUÇÕES</b>
              2.1 Para efeito de REDUÇÃO DE CARÊNCIAS prevista neste aditivo, serão considerados os serviços,
              procedimentos, atendimentos e coberturas previstas na cláusula de carências do contrato principal, desde
              que respeitadas as divisões por grupo de carências, ali constantes.
            </p>
            <p class="mb-1">
              2.2 De acordo com as informações prestadas pelo beneficiário TITULAR CONTRATANTE, as carências previstas
              no contrato principal, em cada uma das divisões mencionadas na cláusula de carências, serão reduzidas de
              acordo com a TABELA DE REDUÇÃO DE CARÊNCIAS abaixo, para o (s) novo (s) beneficiário (s).
            </p>
            <p class="mb-1">
              2.3 Todos os contratos com APROVEITAMENTO DE CARÊNCIAS passarão por análise de aceitação.
            </p>
            <p class="mb-1">
              2.4 Haverá necessidade de comprovação de vínculo associativo, para os filiados a partir de
              {{ inicioFiliacao }} até {{ finalCampanha }};
            </p>
            <p class="mb-1">GRUPO DE CARÊNCIAS</p>
            <p class="mb-1">1º Atendimento de urgência/emergência</p>
            <p class="mb-1">2º Consultas e exames básicos;</p>
            <p class="mb-1">3º Fisioterapia, pequenos procedimentos ambulatoriais e exames especiais;</p>
            <p class="mb-1">4º Internações clínicas e cirúrgicas;</p>
            <p class="mb-1">5º Parto a termo</p>
          </div>
          <div class="tabela-carencias-container col-md-12 col-sm-12" style="padding-right: 0px; padding-left: 0px">
            <p class="tabela-carencias-titulo">CARÊNCIAS PROMOCIONAIS</p>
            <table class="table table-bordered tabela-carencias m-0">
              <thead>
                <tr>
                  <th>GRUPO DE CARÊNCIAS</th>
                  <th class="text-center">1º</th>
                  <th class="text-center">2º</th>
                  <th class="text-center">3º</th>
                  <th class="text-center">4º</th>
                  <th class="text-center">5º</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Para os filiados a partir de {{ inicioFiliacao }} até {{ finalCampanha }}</td>
                  <td class="text-center">Isento</td>
                  <td class="text-center">Isento</td>
                  <td class="text-center">Isento</td>
                  <td class="text-center">Isento</td>
                  <td class="text-center">Isento</td>
                </tr>
                <tr>
                  <td>Para os filiados em outro período</td>
                  <td class="text-center">24 h</td>
                  <td class="text-center">30 dias</td>
                  <td class="text-center">90 dias</td>
                  <td class="text-center">180 dias</td>
                  <td class="text-center">300 dias</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="col-md-12 col-sm-12 mt-1">
            <p class="mb-1">*A redução de carência/isenção não se aplica a CPT. Cobertura Parcial Temporária</p>
            <p class="mb-1">
              *A redução de carências/isenção não é valida para inclusão de dependentes posterior à contratação do
              beneficiário titular.
            </p>
            <p class="mb-1">
              <b>
                Válido para propostas assinadas e encaminhadas para a Operadora no período de {{ inicioCampanha }} a
                {{ finalCampanha }}.
              </b>
            </p>
            <p class="mb-1">
              E por estarem assim justas e contratadas, assinam o presente aditivo contratual em duas vias de igual teor
              para um só efeito. Salientando que o aditivo entrará em vigor, a partir da data de vigência mencionada no
              contrato principal.
            </p>
          </div>
        </div>
      </div>
      <!-- Quadro 2  -->
      <div class="p-2 remover-padding" *ngIf="mostrarQuadroDoisReducaoCarencia">
        <!-- somente pora fesp -->
        <div *ngIf="exibirNaFesp" class="p-1 mb-2" style="background: black; border-radius: 10px">
          <h4 class="col-12 text-center titulo" style="color: #fff">
            <b>SOLICITAÇÃO DE ANÁLISE TÉCNICA PARA REDUÇÃO DE CARÊNCIAS</b>
          </h4>
          <h4 class="col-12 text-center titulo" style="color: #fff">
            (exclusivo para beneficiários oriundos de outras operadoras)
          </h4>
        </div>

        <div class="col-md-12 col-sm-12 mt-1 espacamento-text-mobile">
          <p>
            As informações abaixo deverão ser prestadas pelo beneficiário, em relação a si e seus dependentes, cado
            tenha interesse em submeter-se a análise técnica da administradora:
          </p>
        </div>
        <h3 class="titulo text-center bold-preto-700 mt-1 mb-1 p-1" style="color: black">QUADRO 2</h3>
        <div class="table-responsive">
          <table class="table table-bordered">
            <thead>
              <tr>
                <th style="background: #ccc"></th>
                <th style="background: #ccc">BENEFICIÁRIOS</th>
                <th style="background: #ccc">Data de Nascimento</th>
                <th style="background: #ccc">Operadora</th>
                <th style="background: #ccc">Tempo de Permanência no Plano</th>
                <th *ngIf="exibirNaFesp" style="background: #ccc">Data do último pagamento</th>
              </tr>
            </thead>
            <tbody *ngFor="let item of listaBeneficiariosCarencias">
              <tr>
                <td class="text-center">
                  <b>{{ item.tipoBeneficiario }}</b>
                </td>
                <td class="text-center">{{ item.name }}</td>
                <td class="text-center">{{ item.dataNascimento }}</td>
                <td class="text-center">{{ item.operadora }}</td>
                <td class="text-center">{{ item.tempoPermanencia }}</td>
                <td *ngIf="exibirNaFesp" class="text-center">{{ item.dataUltimoPagamento }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="col-md-12 col-sm-12 mt-1">
          <p class="mb-1 mt-4">
            <b>I) Assinale o tipo de plano do Beneficiário Titular atualmente:</b>
          </p>
          <div class="card-content col-md-12 col-sm-12 mt-1">
            <form [formGroup]="formularioReducaoCarencia">
              <div
                class="form-group col-sm-12 col-md-12 declaracao-options d-flex display-mobile"
                style="margin-bottom: 0px">
                <div *ngFor="let item of listaEnumTipoCotacao" class="row option-row mr-4" style="margin-bottom: 0px">
                  <label class="checkbox-container">
                    <input
                      [readonly]="true"
                      [attr.disabled]="true"
                      formControlName="modalityProduct"
                      [value]="item.value"
                      type="radio"
                      class="hidden-checkbox" />
                    <span class="checkmark"></span>
                    <span class="option-text" style="width: 100%; color: black">{{ item.description }}</span>
                  </label>
                </div>
              </div>
            </form>
          </div>
          <p *ngIf="exibirNaFesp">
            Caso seja Coletivo Empresarial ou Coletivo por Adesão, informar o nome da Entidade/Empresa contratante:
          </p>
          <p class="mt-1 espacamento-text-mobile">
            <b>II) Documento que deverão ser anexados à presente solicitação:</b>
          </p>
          <p>*Se o beneficiário for oriundo de plano de saúde individual/familiar ou coletivo por adesão:</p>
          <p class="ml-2 espacamento-text-mobile">
            <b>a)</b>
            Documento que comprove o início de vigência do plano do titular e seus dependentes, bem como comprovante de
            pagamento da 3 (três) últimas mensalidades; (exigido permanência mínima de 12 meses em plano anterior)
          </p>
          <p class="ml-2 espacamento-text-mobile">
            <b>b)</b>
            RG e CPF do titular e dependentes. (obrigatório CPF do titular e dependentes maiores de 18 anos)
          </p>
          <!-- UDEMO -->
          <p *ngIf="udemo_e_apase" class="mt-1 espacamento-text-mobile">
            *Se o beneficiário for oriundo de plano de saúde individual/familiar ou coletivo por adesão:
          </p>
          <p *ngIf="udemo_e_apase" class="ml-2 espacamento-text-mobile">
            <b>a)</b>
            Documento que comprove o início de vigência do plano do titular e seus dependentes, bem como comprovante de
            pagamento da 3 (três) últimas mensalidades; (exigido permanência mínima de 12 meses em plano anterior)
          </p>
          <!-- UDEMO FIM -->

          <p class="mt-1 espacamento-text-mobile">*Se o beneficiário for oriundo de plano de saúde empresarial:</p>
          <p class="ml-2 espacamento-text-mobile">
            <b>1)</b>
            Carta em papel timbrado da empresa, datada, assinada e carimbada pelo responsável legal, informando que o
            beneficiário participa do plano de saúde contratado pela empresa, bem como: relação de dependentes inscritos
            no plano, nome da operadora, nome e padrão de acomodação do plano de saúde, tempo de permanência do titular
            e dependentes no plano. (exigido permanência mínima de 12 meses em plano anterior)
          </p>
          <p class="mt-1 espacamento-text-mobile">
            <b>III) Declarações do Beneficiário</b>
          </p>
          <p class="espacamento-text-mobile">
            O beneficiário declara estar ciente de que a aceitação ou recusa atenderá a critérios técnicos, sendo certo
            que no caso de recusa da redução de carências, deverão ser cumpridos todos os prazos previstos no contrato
            ao qual aderiu o beneficiário.
          </p>
          <p class="espacamento-text-mobile">
            Declara ainda estar ciente que a análise técnica de redução de carência não contempla a CPT - Cobertura
            Parcial Temporária que é a suspensão, por um período ininterrupto de até 24 (vinte e quatro) meses, da
            cobertura de Procedimentos de Alta Complexidade (PAC), leitos de Alta tecnologia e procedimentos cirúrgicos,
            desde que relacionados exclusivamente às Doenças ou Lesões Preexistentes (DLP) declaradas pelo Beneficiário
            ou seu representante legal, através da Declaração Pessoal de Saúde (DPS).
          </p>
          <p class="espacamento-text-mobile">
            O beneficiário será comunicado, no prazo de 05 (cinco) dias, sobre o resultado da Análise Técnica de Redução
            de Carências. No caso de recusa de redução de carências, o beneficiário e seus dependentes deverão cumprir
            integralmente os prazos de carências contratualmente previstos (conforme QUADRO 1).
          </p>
          <p class="espacamento-text-mobile">
            Após Análise Técnica, caso o beneficiário não tenha interesse em ingressar no plano sem redução de
            carências, poderá solicitar o cancelamento da proposta de adesão, sem ônus, no prazo de 7 dias, contados a
            partir da data de recebimento do comunicado de recusa a que se refere o parágrafo anterior.
          </p>
        </div>
      </div>
    </div>
  </section>
</div>
